// extracted by mini-css-extract-plugin
export default {"problem":"problem_problem__pNu+h","left":"problem_left__jQu8p","tag":"problem_tag__Y3Ekp","right":"problem_right__LTnto","actions":"problem_actions__SyIPN"};